export const getCalculationTypeLabel = (type, keyResult) => {
    const automation = keyResult?.automationConfig;
    const automatic = Boolean(automation?.sourceType && automation.sourceType !== 'manual' && automation.isEnabled !== false);
    if (automatic && automation.sourceType === 'syncro_operations' && automation.metricKey === 'machinesInStockForInstallationCount') {
        return 'Valor automático de inventario';
    }
    if (automatic && (!type || type === 'manual_value')) return 'Valor automático';
    const labels = {
        manual_value: 'Valor manual',
        variance_forecast_vs_real: 'Varianza Forecast vs Real',
        action_completed: 'Acción completada',
        max_allowed: 'Máximo permitido',
        threshold_range: 'Meta con puntos parciales'
    };
    return labels[type] || 'Valor manual';
};
